import { render, staticRenderFns } from "./DashboardFrames.vue?vue&type=template&id=536e9ef2&scoped=true&"
import script from "./DashboardFrames.vue?vue&type=script&lang=js&"
export * from "./DashboardFrames.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFrames.vue?vue&type=style&index=0&id=536e9ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e9ef2",
  null
  
)

export default component.exports